firebird.controller('generalSettingsCtrl', [
    '$rootScope',
    '$scope',
    'analyticsWrapperService',
    'logService',
    'meetingService',
    'socketService',
    'storageService',
    'localizationService',
    'helperService',
    'notificationService',
    'attendeeService',
    'configService',
    function (
        $rootScope,
        $scope,
        analyticsWrapperService,
        logService,
        meetingService,
        socketService,
        storageService,
        localizationService,
        helperService,
        notificationService,
        attendeeService,
        configService
    ) {
        var self = this;

        self.bandwidthSettings = [];
        self.noiseCancellationSettings = [];
        self.denoiseValueChanged = false;
        self.bwSettingLabel = '';
        self.noiseCancellationValue = {};
        self.chosenBWSetting = null;
        self.changeEchoDetectionEnabled = changeEchoDetectionEnabled;
        self.setInitialBWSettings = setInitialBWSettings;
        self.selectBWSetting = selectBWSetting;
        self.initUserSettings = initUserSettings;
        self.saveBWSetting = saveBWSetting;
        self.saveNoiseCancellationSetting = saveNoiseCancellationSetting;
        self.saveAutoVolumeAdjustmentSetting = saveAutoVolumeAdjustmentSetting;
        self.saveEchoDetectionSetting = saveEchoDetectionSetting;
        self.saveAutoEchoDetectionSetting = saveAutoEchoDetectionSetting;
        self.setSelectedBandwidth = setSelectedBandwidth;
        self.saveCurrentTalkerPref = saveCurrentTalkerPref;
        self.saveJoinBeforeHostEnabled = saveJoinBeforeHostEnabled;
        self.saveRecordScreenshareOnly = saveRecordScreenshareOnly;
        self.getShowDesktopNotificationStatus = getShowDesktopNotificationStatus;
        self.getPlayEntryExitSoundStatus = getPlayEntryExitSoundStatus;
        self.onNoiseCancellationSettingSelected = onNoiseCancellationSettingSelected;
        self.isDenoiseCurrentlySelected = isDenoiseCurrentlySelected;
        self.getNoiseReductionTooltip = getNoiseReductionTooltip;
        self.getEchoDetectionTooltip = getEchoDetectionTooltip;
        self.e2eeEnabled = e2eeEnabled;

        self.getDeviceSelectionTooltip = getDeviceSelectionTooltip;

        self.settings = {};

        self.cancel = cancel;
        self.save = save;
        self.initSettings = initSettings;
        self.isPlayEntryExitSoundsInitialized = false;

        self.isAttendee = !attendeeService.getIsHost();
        self.settings.attendeeJoinAudioStatePref = true;

        self.settings.meetingReactionsOn = true;
        self.settings.meetingLockAudioPromptsEnabled = false;
        self.settings.echoDetectionEnabled = false;
        self.settings.autoEchoDetectionEnabled = false;
        self.settings.autoVolumeAdjustmentValue = false;
        self.settings.joinBeforeHostEnabled = false;
        self.settings.recordScreenshareOnly = false;
        self.settings.recordingOptionsEnabled = false;

        // the default value for the denoise setting should be sent from the server (there is the same code in meeting.js)
        // this code is needed for edge case when the server returns null value (probably when we somehow got initial-payload before data loaded from API)
        self.mediumDenoiseSettingValue = 'medium';

        self.settings.playMutedAudioPrompts = false;

        self.shouldShowDeviceReviewSection = shouldShowDeviceReviewSection;
        self.shouldShowCompactModeSetting = shouldShowCompactModeSetting;

        self.denoiseFeatureEnabled = attendeeService.getIsHost();
        self.echoDetectionFeatureEnabled = false;
        self.volumeEnhancementSettingsVisible = attendeeService.getIsHost();

        self.showOptimizeCPUPerformanceCheckbox = meetingService.getEnableAutoPerformanceMode() === false;
        self.saveImprovePerformanceSetting = saveImprovePerformanceSetting;
        self.settings.improvePerformance = false;

        self.audioDisconnectEnabled = meetingService.getEnableAudioDisconnect;
        self.shouldShowRecordingOptions = shouldShowRecordingOptions;

        $scope.$on('update-local-join-audio-muted', onUpdateLocalJoinAudioMuted);
        $scope.$on('play-entry-exit-sounds-updated', onPlayEntryExitSoundsUpdated);

        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);

        $scope.$on('desktop-notifications-updated', onShowDesktopNotificationsUpdated);

        $scope.$on('meetingReactionsOn-updated', onMeetingReactionsOnUpdated);
        $scope.$on('meetingLockAudioPromptsEnabled-updated', onMeetingLockAudioPromptsEnabled);

        init();

        ////////////////////////

        function init() {
            logService.log('generalSettingsCtrl init');
            self.setInitialBWSettings(); //Populates bandwidth array
            self.setSelectedBandwidth(); //Updates currently selected BW based on storageService value
            self.initUserSettings();
            self.initSettings();
            self.recordingOptionsEnabled = self.shouldShowRecordingOptions();
            digest();
        }

        function initSettings() {
            var currentAttendeeJoinPreference =
                storageService.get('attendeeJoinAudioStatePref') === true ? true : false;
            self.settings.newAttendeesJoinMuted = meetingService.getJoinAudioMuted();

            // Reactions
            self.settings.meetingReactionsOn = meetingService.getMeetingReactionsOn();
            self.settings.joinBeforeHostEnabled = meetingService.getJoinBeforeHostEnabled();
            self.settings.recordScreenshareOnly = meetingService.getRecordScreenshareOnly();

            // Meeting Lock Audio Prompts
            self.settings.meetingLockAudioPromptsEnabled = meetingService.getMeetingLockAudioPromptsEnabled();

            self.settings.echoDetectionEnabled = meetingService.getEchoDetectionState();
            self.settings.autoEchoDetectionEnabled = meetingService.getAutoEchoDetectionState();
            self.settings.joinMeetingMicUnmuted =
                storageService.get('join-flow-audio-muted') === null
                    ? false
                    : !storageService.get('join-flow-audio-muted');

            self.getPlayEntryExitSoundStatus();

            if (attendeeService.getIsHost()) {
                self.getShowDesktopNotificationStatus();
            } else {
                self.settings.showDesktopNotifications =
                    storageService.get('showDesktopNotifications') === true ? true : false;
            }

            if (storageService.get('attendeeJoinAudioStatePref') !== null) {
                self.settings.attendeeJoinAudioStatePref = currentAttendeeJoinPreference;
            } else {
                self.settings.attendeeJoinAudioStatePref = true;
            }

            self.settings.showDeviceSelection = !storageService.get('do-not-show-device-selection-flow');

            self.settings.showCurrentTalker = meetingService.shouldShowCurrentTalker();

            self.settings.playMutedAudioPrompts = attendeeService.getMutedPromptSettingState();

            self.settings.launchCompactMode = storageService.get('launchCompactMode') === true;

            self.settings.showNoAudioPrompt = storageService.get('showNoAudioPrompt') !== false;

            var advancedSettings = JSON.parse(storageService.get('advancedSettings') || '{}');
            self.settings.improvePerformance = advancedSettings.videoLow == 'true' ? true : false;
        }

        function getPlayEntryExitSoundStatus() {
            self.isPlayEntryExitSoundsInitialized = false;

            var msgObj = {};
            msgObj.message = 'get-play-entry-exit-sounds';
            msgObj.callback = function (result) {
                logService.log('getPlayEntryExitSounds result received from meeting server', result);
                if (result) {
                    self.settings.playChimes = result.playEntryExitSounds;
                    self.isPlayEntryExitSoundsInitialized = true;
                }
            };
            socketService.send(msgObj);
        }

        //Receives the callback from the server meeting.js
        function getShowDesktopNotificationStatus() {
            var msgObj = {};
            msgObj.message = 'get-show-desktop-notifications';
            msgObj.callback = function (result) {
                logService.log('Result received from server For showing Desktop Notifications', result);
                if (result) {
                    self.settings.showDesktopNotifications = result.showDesktopNotifications;
                    notificationService.determineIfShowingDesktopNotifications(self.settings.showDesktopNotifications);
                }
            };
            socketService.send(msgObj);
        }

        function onUpdateLocalJoinAudioMuted() {
            self.settings.newAttendeesJoinMuted = meetingService.getJoinAudioMuted();
        }

        function onPlayEntryExitSoundsUpdated(e, data) {
            self.settings.playChimes = data.playEntryExitSounds;
        }

        function onShowDesktopNotificationsUpdated(e, data) {
            self.settings.showDesktopNotifications = data.showDesktopNotifications;
            notificationService.determineIfShowingDesktopNotifications(self.settings.showDesktopNotifications);
        }

        function onMeetingReactionsOnUpdated(e, newMeetingReactionsOn) {
            self.settings.meetingReactionsOn = newMeetingReactionsOn;
        }

        function onMeetingLockAudioPromptsEnabled(e, newMeetingLockAudioPromptsEnabled) {
            self.settings.meetingLockAudioPromptsEnabled = newMeetingLockAudioPromptsEnabled;
        }

        // since it bind to ng-change attribute, this will occur after model value changed
        function changeEchoDetectionEnabled() {
            self.settings.autoEchoDetectionEnabled =
                self.settings.echoDetectionEnabled && self.settings.autoEchoDetectionEnabled;
        }

        function save() {
            saveAttendeeJoinAudioStatePref();
            saveJoinMeetingMicUnmuted();
            saveHostPrefJoinAudioForAttendees();
            savePlayChimes();
            saveShowDesktopNotifications();
            saveMutedPromptSetting();
            self.saveBWSetting();
            self.saveNoiseCancellationSetting();
            self.saveAutoVolumeAdjustmentSetting();
            self.saveEchoDetectionSetting();
            saveShowDeviceSelection();
            saveMeetingReactionsOn();
            saveMeetingLockAudioPromptsEnabled();
            saveCompactModeSetting();
            saveDisableNoAudioAlertSetting();

            self.saveCurrentTalkerPref();
            self.saveImprovePerformanceSetting();
            self.saveJoinBeforeHostEnabled();
            self.saveRecordScreenshareOnly();
        }

        function saveCompactModeSetting() {
            storageService.set('launchCompactMode', self.settings.launchCompactMode);
        }

        function saveDisableNoAudioAlertSetting() {
            storageService.set('showNoAudioPrompt', self.settings.showNoAudioPrompt);
        }

        function saveImprovePerformanceSetting() {
            var advancedSettings = JSON.parse(storageService.get('advancedSettings') || '{}');

            if (self.settings.improvePerformance) {
                advancedSettings.videoLow = 'true';
            } else {
                delete advancedSettings.videoLow;
            }

            storageService.set('advancedSettings', JSON.stringify(advancedSettings));
            $rootScope.$broadcast('apply-low-cpu-mode', {
                value: self.settings.improvePerformance,
                reason: 'config'
            });
        }

        function saveCurrentTalkerPref() {
            //Storage value is 'true' if user disabled the Current Talker feature
            var previousPref = !!storageService.get('disable-current-talker');
            if (previousPref === self.settings.showCurrentTalker) {
                storageService.set('disable-current-talker', !self.settings.showCurrentTalker);
            }
        }

        //this function determines if the host wants there attendees to join muted
        function saveHostPrefJoinAudioForAttendees() {
            if (!attendeeService.getIsHost()) {
                logService.log('joinAudioMuted will not be updated for not a host');
                return;
            }

            logService.log('Sending new joinAudioMuted val to server:', self.settings.newAttendeesJoinMuted);

            analyticsWrapperService.eventTrack('Meeting - Attendee List - Join-Audio-Muted Checkbox Toggled');

            socketService.send({
                message: 'set-join-audio-muted',
                data: {
                    joinAudioMuted: self.settings.newAttendeesJoinMuted
                }
            });
        }

        //Saves the users preference and sends that new preference to the server
        function saveShowDesktopNotifications() {
            var previousShowDesktopNotifications =
                storageService.get('showDesktopNotifications') === true ? true : false;

            if (attendeeService.getIsHost()) {
                //If Attendee is the host we want to give the analytics, then set the value in notification Service
                //After that we update the server User Pair and then update the local storage so it will transfer across meetings
                //for the attendee
                analyticsWrapperService.eventTrack(
                    'Meeting - Notifications - host-desktop-notifications Checkbox Toggled'
                );
                notificationService.determineIfShowingDesktopNotifications(self.settings.showDesktopNotifications);
                socketService.send({
                    message: 'set-show-desktop-notifications',
                    data: {
                        showDesktopNotifications: self.settings.showDesktopNotifications
                    }
                });

                if (previousShowDesktopNotifications !== self.settings.showDesktopNotifications) {
                    storageService.set('showDesktopNotifications', self.settings.showDesktopNotifications);
                }
            } else {
                analyticsWrapperService.eventTrack(
                    'Meeting - Notifications - attendee-desktop-notifications Checkbox Toggled'
                );
                //If its an attendee we only want to update local storage and set the notification value
                notificationService.determineIfShowingDesktopNotifications(self.settings.showDesktopNotifications);
                if (previousShowDesktopNotifications !== self.settings.showDesktopNotifications) {
                    storageService.set('showDesktopNotifications', self.settings.showDesktopNotifications);
                }
            }
        }

        function saveMutedPromptSetting() {
            attendeeService.setMutedPromptSettingState(self.settings.playMutedAudioPrompts);
        }

        //This sets the preference for for an attendee to join either muted or unmuted
        function saveAttendeeJoinAudioStatePref() {
            //store the value locally So that attendees can be updated
            storageService.set('attendeeJoinAudioStatePref', self.settings.attendeeJoinAudioStatePref);
        }

        function savePlayChimes() {
            if (!attendeeService.getIsHost()) {
                logService.log('playEntryExitSounds will not be updated for not a host');
                return;
            }

            logService.log('Sending new playEntryExitSounds val to server:', self.settings.playChimes);

            analyticsWrapperService.eventTrack('Meeting - Attendee List - Play-entry-exit-sound Checkbox Toggled');

            socketService.send({
                message: 'set-play-entry-exit-sounds',
                data: {
                    playEntryExitSounds: self.settings.playChimes
                }
            });
        }

        function saveShowDeviceSelection() {
            var previous = !storageService.get('do-not-show-device-selection-flow');
            logService.log(
                'do-not-show-device-selection-flow ' + !!previous + ' => ' + !!self.settings.showDeviceSelection
            );
            if (previous !== self.settings.showDeviceSelection) {
                if (!self.settings.showDeviceSelection) {
                    storageService.set('do-not-show-device-selection-flow', !self.settings.showDeviceSelection);
                } else {
                    storageService.remove('do-not-show-device-selection-flow');
                }
            }
        }

        function saveJoinMeetingMicUnmuted() {
            storageService.set('join-flow-audio-muted', !self.settings.joinMeetingMicUnmuted);
        }

        function saveMeetingReactionsOn() {
            if (!attendeeService.getIsHost()) {
                logService.log('meetingReactionsOn will not be updated for not a host');
                return;
            }

            logService.log("Sending new 'meetingReactionsOn' val to server:", self.settings.meetingReactionsOn);

            analyticsWrapperService.eventTrack('Meeting - General Settings - meetingReactionsOn Checkbox Toggled');

            socketService.send({
                message: 'set-meetingReactionsOn',
                data: { meetingReactionsOn: self.settings.meetingReactionsOn }
            });
        }

        function saveJoinBeforeHostEnabled() {
            if (!attendeeService.getIsHost()) {
                logService.log('joinBeforeHostEnabled will not be updated for not a host');
                return;
            }

            const previousJoinBeforeHostValue = meetingService.getJoinBeforeHostEnabled();
            if (previousJoinBeforeHostValue !== self.settings.joinBeforeHostEnabled) {
                logService.log(
                    "Sending new 'joinBeforeHostEnabled' val to server:",
                    self.settings.joinBeforeHostEnabled
                );

                socketService.send({
                    message: 'set-joinBeforeHostEnabled',
                    data: { joinBeforeHostEnabled: self.settings.joinBeforeHostEnabled },
                    callback: ({ result }) => {
                        if (!result) {
                            logService.log('Something went wrong during joinBeforeHostEnabled update');
                            return;
                        }

                        meetingService.setJoinBeforeHostEnabled(self.settings.joinBeforeHostEnabled);

                        if (self.settings.joinBeforeHostEnabled) {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Join before host switched on'
                            );
                        } else {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Join before host switched off'
                            );
                        }
                    }
                });
            }
        }

        function saveRecordScreenshareOnly() {
            if (!attendeeService.getIsHost()) {
                logService.log('recordScreenshareOnly will not be updated for not a host');
                return;
            }

            const previousRecordScreenshareOnlyValue = meetingService.getRecordScreenshareOnly();
            if (previousRecordScreenshareOnlyValue !== self.settings.recordScreenshareOnly) {
                logService.log(
                    "Sending new 'RecordScreenshareonly' val to server:",
                    self.settings.recordScreenshareOnly
                );

                socketService.send({
                    message: 'set-recordScreenshareOnly',
                    data: { recordScreenshareOnlyEnabled: self.settings.recordScreenshareOnly },
                    callback: ({ result }) => {
                        if (!result) {
                            logService.log('Something went wrong during RecordScreenshareonly update');
                            return;
                        }

                        meetingService.setRecordScreenshareOnly(self.settings.recordScreenshareOnly);

                        analyticsWrapperService.eventTrack(
                            `Meeting - General Settings - Record screenshare only ${
                                self.settings.recordScreenshareOnly ? 'on' : 'off'
                            }`
                        );
                    }
                });
            }
        }

        function saveMeetingLockAudioPromptsEnabled() {
            if (!attendeeService.getIsHost()) {
                logService.log('meetingLockAudioPromptsEnabled will not be updated for not a host');
                return;
            }

            logService.log(
                "Sending new 'meetingLockAudioPromptsEnabled' val to server:",
                self.settings.meetingLockAudioPromptsEnabled
            );

            analyticsWrapperService.eventTrack(
                'Meeting - General Settings - meetingLockAudioPromptsEnabled Checkbox Toggled'
            );

            socketService.send({
                message: 'set-meetingLockAudioPromptsEnabled',
                data: { meetingLockAudioPromptsEnabled: self.settings.meetingLockAudioPromptsEnabled }
            });
        }

        function cancel() {
            self.initSettings();
            self.setSelectedBandwidth();

            if (self.denoiseFeatureEnabled) {
                setCurrentNoiseCancellationSetting();
            }
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'general-settings';

                if (data.openedTab === tabName) {
                    logService.log('General Settings Tab opened');
                } else if (data.closedTab === tabName) {
                    logService.log('General Settings Tab closed');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data && data.applyChanges) {
                logService.log('General Settings - applying changes');
                self.save();
            } else {
                logService.log('General Settings - closing without applying changes');
                self.cancel();
            }
        }

        function setInitialBWSettings() {
            self.bwSettingLabel = localizationService.translate('HEADER.SETTINGS.BANDWIDTH.AUTOMATIC');
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.AUTOMATIC'),
                clear: true
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.HIGHT'),
                setting: {
                    id: 'high-1',
                    standard: 2000000,
                    simulcastTotal: 3000000,
                    simulcast: { high: 2500000, medium: 400000, low: 100000 }
                }
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.MEDIUM'),
                setting: {
                    id: 'med-1',
                    standard: 1000000,
                    simulcastTotal: 1500000,
                    simulcast: { high: 1000000, medium: 400000, low: 100000 }
                }
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.LOW'),
                setting: {
                    id: 'low-1',
                    standard: 500000,
                    simulcastTotal: 750000,
                    simulcast: { high: 425000, medium: 250000, low: 75000 }
                }
            });
        }

        function setInitialNoiseCancellationSettings() {
            self.noiseCancellationSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.OFF'),
                key: 'off'
            });
            self.noiseCancellationSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.LOW'),
                key: 'low'
            });
            self.noiseCancellationSettings.push({
                label:
                    localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.MEDIUM') +
                    ' (' +
                    localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.DEFAULT') +
                    ')',
                key: 'medium'
            });
            self.noiseCancellationSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.HIGH'),
                key: 'high'
            });

            setCurrentNoiseCancellationSetting();
        }

        function initUserSettings() {
            initEchoDetectionFeatureEnabled();
            if (self.denoiseFeatureEnabled) {
                setInitialNoiseCancellationSettings();
            }
        }

        function getDefaultNoiceCancellationValue() {
            let denoiseSettingValue = self.mediumDenoiseSettingValue;

            return self.noiseCancellationSettings.find(function (item) {
                return item.key === denoiseSettingValue;
            });
        }

        //When user clicks a new BW option from the dropdown
        function selectBWSetting(setting) {
            if (setting.clear) {
                self.chosenBWSetting = null;
                self.bwSettingLabel = self.bandwidthSettings[0].label;
                return;
            }

            self.chosenBWSetting = setting;
            switch (setting.setting.id) {
                case 'high-1':
                    self.bwSettingLabel = self.bandwidthSettings[1].label;
                    break;
                case 'med-1':
                    self.bwSettingLabel = self.bandwidthSettings[2].label;
                    break;
                case 'low-1':
                    self.bwSettingLabel = self.bandwidthSettings[3].label;
                    break;
                default:
                    break;
            }
        }

        function onNoiseCancellationSettingSelected(noiseCancellationSetting) {
            self.denoiseValueChanged = true;

            var item = self.noiseCancellationSettings.find(function (item) {
                return item.key === noiseCancellationSetting.key;
            });

            self.noiseCancellationValue = item;
        }

        function isDenoiseCurrentlySelected(denoiseObj) {
            return denoiseObj.key === self.noiseCancellationValue.key;
        }

        function setCurrentNoiseCancellationSetting() {
            self.settings.autoVolumeAdjustmentValue = meetingService.getAutoVolumeAdjustment();

            var denoiseValue = meetingService.getDenoiseValue();
            if (denoiseValue) {
                var item = self.noiseCancellationSettings.find(function (item) {
                    return item.key === denoiseValue;
                });

                if (!item) {
                    self.noiseCancellationValue = {
                        label: localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.EXPERIMENTAL'),
                        key: 'experimental',
                        value: denoiseValue
                    };
                } else {
                    self.noiseCancellationValue = item;
                }
            } else {
                var defaultDenoise = JSON.parse(JSON.stringify(getDefaultNoiceCancellationValue()));
                self.noiseCancellationValue = defaultDenoise;
            }
        }

        //Updates dropdown label
        function setSelectedBandwidth() {
            var storageItem = storageService.get('sfu-bandwidth');
            if (storageItem) {
                storageItem = JSON.parse(storageItem);
                switch (storageItem.id) {
                    case 'high-1':
                        self.bwSettingLabel = self.bandwidthSettings[1].label;
                        break;
                    case 'med-1':
                        self.bwSettingLabel = self.bandwidthSettings[2].label;
                        break;
                    case 'low-1':
                        self.bwSettingLabel = self.bandwidthSettings[3].label;
                        break;
                    default:
                        break;
                }
            } else {
                self.bwSettingLabel = self.bandwidthSettings[0].label;
            }
        }

        function saveBWSetting() {
            var previousBandwidth = storageService.get('sfu-bandwidth');
            var previousParsed = null;
            var videoInputChanged = false;

            if (previousBandwidth) {
                try {
                    previousParsed = JSON.parse(previousBandwidth);
                } catch (e) {} // stored setting can be treated like null here ... it's about to get overwritten anyways
            }

            if (!self.chosenBWSetting) {
                if (previousParsed) {
                    videoInputChanged = true;
                }
                logService.log('Saving bandwidth setting: default');
                storageService.remove('sfu-bandwidth');
            } else {
                if (!previousParsed || previousParsed.id !== self.chosenBWSetting.setting.id) {
                    videoInputChanged = true;
                }
                var bwSettingString = JSON.stringify(self.chosenBWSetting.setting);
                logService.log('Saving bandwidth setting:', bwSettingString);
                storageService.set('sfu-bandwidth', bwSettingString);
            }

            if (videoInputChanged) {
                //Broadcasts event to videoroomCtrl to republish the video stream with new bandwidth quality
                $rootScope.$broadcast('finished-media-device-selection', {
                    newVideoInputDeviceSelected: true
                });
            }
        }

        function saveNoiseCancellationSetting() {
            var previousDenoiseValue = meetingService.getDenoiseValue();

            if (self.denoiseValueChanged && self.noiseCancellationValue.key !== previousDenoiseValue) {
                meetingService.setDenoiseValue(self.noiseCancellationValue.key);
                socketService.send({
                    message: 'fs-denoise',
                    data: { denoiseValue: self.noiseCancellationValue.key }
                });
            }
        }

        function saveAutoVolumeAdjustmentSetting() {
            const previousAutoVolumeAdjustmentValue = meetingService.getAutoVolumeAdjustment();

            if (
                helperService.notNullOrUndefined(self.settings.autoVolumeAdjustmentValue) &&
                self.settings.autoVolumeAdjustmentValue !== previousAutoVolumeAdjustmentValue
            ) {
                socketService.send({
                    message: 'set-auto-volume-adjustment',
                    data: { autoVolumeAdjustment: self.settings.autoVolumeAdjustmentValue },
                    callback: response => {
                        if (!response.result) {
                            logService.log('Something went wrong during autoVolumeAdjustment update');
                            return;
                        }

                        meetingService.setAutoVolumeAdjustment(self.settings.autoVolumeAdjustmentValue);

                        if (self.settings.autoVolumeAdjustmentValue) {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Auto volume adjustment switched on'
                            );
                        } else {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Auto volume adjustment switched off'
                            );
                        }
                    }
                });
            }
        }

        function saveEchoDetectionSetting() {
            const previousEchoDetectionValue = meetingService.getEchoDetectionState();
            if (
                helperService.notNullOrUndefined(self.settings.echoDetectionEnabled) &&
                previousEchoDetectionValue !== self.settings.echoDetectionEnabled
            ) {
                socketService.send({
                    message: 'fs-echo-detection',
                    data: {
                        echoDetectionValue: self.settings.echoDetectionEnabled
                    },
                    callback: response => {
                        if (!response.result) {
                            logService.log('Something went wrong during echoDetectionEnabled update');
                            return;
                        }

                        meetingService.setEchoDetectionState(self.settings.echoDetectionEnabled);

                        if (self.settings.echoDetectionEnabled) {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Echo loop detection switched on'
                            );
                        } else {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Echo loop detection switched off'
                            );

                            self.settings.autoEchoDetectionEnabled = false;
                            meetingService.setAutoEchoDetectionState(self.settings.autoEchoDetectionEnabled);
                        }

                        // this call will make sure that autoEcho setting will be saved only after echoDetection setting
                        self.saveAutoEchoDetectionSetting();
                    }
                });
            } else {
                // this call make sure that in case echoDetection was not changed, settings will attempt to save autoEcho anyway
                self.saveAutoEchoDetectionSetting();
            }
        }

        /**
         * This function is supposed to be called only after saveEchoDetectionSettings
         */
        function saveAutoEchoDetectionSetting() {
            const previousAutoEchoDetectionValue = meetingService.getAutoEchoDetectionState();
            if (
                helperService.notNullOrUndefined(self.settings.autoEchoDetectionEnabled) &&
                previousAutoEchoDetectionValue !== self.settings.autoEchoDetectionEnabled
            ) {
                socketService.send({
                    message: 'set-auto-echo-detection',
                    data: {
                        autoEchoDetectionEnabled: self.settings.autoEchoDetectionEnabled
                    },
                    callback: response => {
                        if (!response.result) {
                            logService.log('Something went wrong during autoEchoDetectionEnabled update');
                            return;
                        }

                        meetingService.setAutoEchoDetectionState(self.settings.autoEchoDetectionEnabled);

                        if (self.settings.autoEchoDetectionEnabled) {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Auto echo loop detection switched on'
                            );
                        } else {
                            analyticsWrapperService.eventTrack(
                                'Meeting - General Settings - Auto echo loop detection switched off'
                            );
                        }
                    }
                });
            }
        }

        function initEchoDetectionFeatureEnabled() {
            self.echoDetectionFeatureEnabled = attendeeService.getIsHost() && meetingService.getEchoDetectionEnabled();
        }

        function getNoiseReductionTooltip() {
            if (meetingService.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_NOISE_CANCELLATION_DISABLED');
            } else {
                return localizationService.translate('HEADER.SETTINGS.NOISE_CANCELLATION.TOOLTIP');
            }
        }

        function getEchoDetectionTooltip() {
            if (meetingService.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_ECHO_DETECTION_DISABLED');
            } else {
                return localizationService.translate('HEADER.SETTINGS.ECHO_DETECTION.ECHO_DETECTION_TOOLTIP');
            }
        }

        function e2eeEnabled() {
            return meetingService.e2eeEnabled();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function shouldShowDeviceReviewSection() {
            return meetingService.getDeviceSelectionEnabled();
        }

        function shouldShowCompactModeSetting() {
            return meetingService.getCompactModeAvailable();
        }

        function getDeviceSelectionTooltip() {
            if (meetingService.getVerticalJoinFlowEnabled()) {
                return localizationService.translate('HEADER.SETTINGS.SHOW_JOIN_FLOW');
            } else {
                return localizationService.translate('HEADER.SETTINGS.SHOW_DEVICE_SELECTION');
            }
        }

        function shouldShowRecordingOptions() {
            return configService.getServerValue('recordingScreenshareOnlyAvailable') == 'true';
        }
    }
]);
